import { getCountryList } from '@dvag/dfs-constant-config/get-country-list';
import { useQuery } from '@tanstack/react-query';
import { personApi } from 'service/api/personApi';
import { normalizeCustomerStatus } from 'type/customerStatus';
import { mapCustomerAddress } from './mapCustomerAddress';

export const useHouseholdList = (householdId?: string) => {
  const countryList = getCountryList();
  const personService = personApi();

  return useQuery({
    queryKey: ['last-accessed'],
    queryFn: async () => {
      const response = await personService.getLastAccessed();

      return (response.data || []).map((household) => ({
        address: mapCustomerAddress(household.address || {}, countryList),
        householdId: household.id,
        personList: (household.personInHouseholdList || []).map((person) => {
          const status = normalizeCustomerStatus(person.status);

          return {
            firstName: person.firstName,
            id: person.id,
            lastName: person.lastName,
            order: person.order,
            ...(status ? { status } : {}),
          };
        }),
      }));
    },
    initialData: [],
    enabled: !householdId,
  });
};
